module.exports = __webpack_public_path__ + "static/media/Artboard4.58638617.png";